export const passwordCharacters = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '<'];

export const PASSWORD_LENGTH = 4;

export const EXCEPTION_INTERVAL = 2000;

export * from './customer/default/parentalCode.constants';
